import { Player } from "@lottiefiles/react-lottie-player";

export default function Preloader() {
    // states


    // comportements


    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                <Player
                    autoplay
                    loop
                    src="/assets/imgs/anim2.json"
                    style={{width: '496px', display: "block", marginLeft: "auto", marginRight: "auto", marginTop: 196, marginBottom: 196 }}
                    >
                </Player>
            </div>
        </div>
    )
}